showPreloader = (show, time = 5000, onShow = () => {}) => {
    const preloadWrapperElement = document.querySelector('.preload-wrapper')
    if (show) {
        if (localStorage.getItem('preloaded') === 'yes') {
            return;
        }
        localStorage.setItem('preloaded', 'yes')
        preloadWrapperElement.style.display = 'block'
        onShow()
        if (time) {
            setTimeout(() => {
                showPreloader(false)
            }, time)
        }
    } else {
        preloadWrapperElement.style.display = 'none'
    }
}

showPreloaderSpinShakeImage = (show, time = 3000, onComplete = () => {}) => {
    if (show) {
      	const preloaderContentElement = document.querySelector('.preload-content')
      	const preloadSpinShakeImage = document.createElement('img')
        preloadSpinShakeImage.src = "//bezelled.com/cdn/shop/t/4/assets/bezelled-gold.png?v=80872212507693482341650042399"
        preloadSpinShakeImage.setAttribute('alt', 'Bezelled Preloader - White')
        preloadSpinShakeImage.classList.add('spin-shake')
        preloaderContentElement.appendChild(preloadSpinShakeImage)
        if (time) {
            setTimeout(() => {
                showPreloaderSpinShakeImage(false)
            	onComplete()
            }, time)
        }
    } else {
    	const preloadSpinShakeImageElement = document.querySelector('img.spin-shake')
        preloadSpinShakeImageElement.remove()
    }
}

showPreloaderScaleImage = (show, time = 2000, onComplete = () => {}) => {
    if (show) {
      	const preloaderContentElement = document.querySelector('.preload-content')
      	const preloadScaleImage = document.createElement('img')
        preloadScaleImage.src = "//bezelled.com/cdn/shop/t/4/assets/bezelled-gold.png?v=80872212507693482341650042399"
        preloadScaleImage.setAttribute('alt', 'Bezelled Preloader - Gold')
        preloadScaleImage.classList.add('scale')
        preloaderContentElement.appendChild(preloadScaleImage)
        if (time) {
            setTimeout(() => {
                showPreloaderScaleImage(false)
            	onComplete()
            }, time)
        }
    } else {
    	const preloadScaleImageElement = document.querySelector('img.scale')
        preloadScaleImageElement.remove()
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const preloadFrag = document.createDocumentFragment()
    const preloadWrapper = document.createElement('div')
    preloadWrapper.classList.add('preload-wrapper')
    const preloadContent = document.createElement('div')
    preloadContent.classList.add('preload-content')
    preloadWrapper.appendChild(preloadContent)
    preloadFrag.appendChild(preloadWrapper)
    document.body.prepend(preloadFrag)
    showPreloader(true, 5000, () => {
          showPreloaderSpinShakeImage(true, 3000, () => {
          showPreloaderScaleImage(true)
    	})
    })
})

/*window.onload = () => {
    showPreloader(false) 
}*/